<div class="error-state" [class]="`error-state--${type()}`">
  <div class="error-state__image">
    <ftr-illustration class="error-state__illustration" [illustration]="illustration.Error" />
    <svg class="error-state__icon" ftrIcon="ErrorCircleLine" [iconSize]="24" iconColor="Brand50" />
  </div>
  <div class="error-state__content">
    @let errorMsg = errorMessage();
    @let config = customConfiguration();

    @if (config) {
      <ng-container
        *ngTemplateOutlet="
          textContent;
          context: { title: config.title, actionName: config.actionName, message: config.message }
        "
      />
    } @else if (errorMsg) {
      <span class="error-state__error-message">{{ errorMsg }}</span>
    } @else {
      @let entity = entityName() | ftrCapitalizeFirstLetter;
      <ng-container
        *ngTemplateOutlet="
          textContent;
          context: {
            title: 'Failed to Load' + (entity ? ' ' + entity : ''),
            actionName: 'Reload Page',
            message: 'Please reload the page or try again later.',
          }
        "
      />
    }
  </div>
</div>

<ng-template #textContent let-title="title" let-message="message" let-actionName="actionName">
  <div class="error-state__text-content">
    <div class="error-state__title">
      <h2>{{ title }}</h2>
      <h3>{{ title }}</h3>
      <h4>{{ title }}</h4>
    </div>
    <span>{{ message }}</span>
    <ftr-tertiary-button (onClick)="action.emit()" theme="primary" [text]="actionName" />
  </div>
</ng-template>
